// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экраны 12–13 «API» (утверждены 28.10.2026). */
.ap-card-head {
  padding: 14px 16px 6px;
}
.ap-table tbody tr {
  cursor: pointer;
}
.ap-table tbody tr:hover,
.ap-table tbody tr.is-on {
  background: var(--v2-bg);
}
.ap-row-btn {
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  font-weight: 600;
  color: var(--v2-primary);
  cursor: pointer;
}
.ap-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 999px;
  background: var(--v2-green-bg);
  color: var(--v2-green-text);
  font-size: 12px;
  font-weight: 600;
}
.ap-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 16px;
  align-items: start;
}
.ap-card {
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}
.ap-h {
  font-size: 16px;
}
.ap-p {
  margin: 0;
  line-height: 1.5;
}
.ap-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ap-label {
  font-weight: 600;
  font-size: 13px;
}
.ap-label-row {
  font-size: 13px;
  flex: 1;
  min-width: 200px;
}
.ap-req {
  color: var(--v2-red);
}
.ap-err {
  color: var(--v2-red);
}
.ap-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.ap-ai {
  height: 30px;
  padding: 0 12px;
  font-weight: 500;
}
.ap-input {
  font: inherit;
  font-size: 14px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  color: var(--v2-primary);
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  outline: none;
}
.ap-input:focus {
  border-color: var(--v2-primary);
}
.ap-input.is-error {
  border-color: var(--v2-red);
}
.ap-textarea {
  height: auto;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.45;
}
.ap-choice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
  border: 1px solid var(--v2-border);
  border-radius: 10px;
  padding: 12px 16px;
  background: #fff;
  font: inherit;
  cursor: pointer;
  color: var(--v2-primary);
}
.ap-choice > span:last-child {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ap-choice.is-on {
  border: 2px solid var(--v2-primary);
  padding: 11px 15px;
}
.ap-choice-t {
  font-weight: 600;
  font-size: 14px;
}
.ap-radio {
  flex: none;
  width: 14px;
  height: 14px;
  margin-top: 3px;
  border-radius: 50%;
  border: 1.5px solid #9ca3af;
  box-sizing: border-box;
}
.ap-choice.is-on .ap-radio {
  border: 4px solid var(--v2-blue);
}
.ap-submit {
  height: 44px;
  border: 0;
  border-radius: 10px;
  background: var(--v2-primary);
  color: #fff;
  font: inherit;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}
.ap-submit:disabled {
  opacity: 0.6;
  cursor: default;
}
.ap-existing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--v2-border-soft);
}
.ap-existing-sel {
  flex: 1;
  min-width: 160px;
  height: 34px;
}
.ap-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ap-chip {
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--v2-hover);
  font-size: 12px;
  color: var(--v2-text-2);
}
.ap-fresh {
  border: 1px solid #86efac;
  background: #f0fdf4;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--v2-green-text);
}
.ap-fresh-t {
  font-weight: 700;
  font-size: 14px;
}
.ap-fresh-row {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.ap-fresh-key {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  background: #fff;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 7px 10px;
  color: var(--v2-primary);
  word-break: break-all;
  user-select: all;
}
.ap-fresh-kb {
  align-self: flex-start;
}
.ap-key {
  background: var(--v2-bg);
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.ap-key-mask {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: var(--v2-primary);
}
.ap-key-btns {
  display: flex;
  gap: 6px;
}
.ap-off {
  color: var(--v2-red);
}
.ap-off:hover {
  border-color: var(--v2-red);
}
.ap-tabs {
  display: flex;
  gap: 6px;
}
.ap-tab {
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--v2-border);
  border-radius: 8px;
  background: #fff;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  color: var(--v2-primary);
}
.ap-tab.is-on {
  background: var(--v2-primary);
  border-color: var(--v2-primary);
  color: #fff;
  font-weight: 600;
}
.ap-code-wrap {
  position: relative;
}
.ap-code {
  margin: 0;
  background: #1f2937;
  color: #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  font-size: 12.5px;
  line-height: 1.6;
  overflow-x: auto;
}
.ap-code-copy {
  position: absolute;
  top: 8px;
  right: 8px;
  border: 1px solid #4b5563;
  background: #374151;
  color: #e5e7eb;
  border-radius: 6px;
  font: inherit;
  font-size: 11px;
  padding: 3px 8px;
  cursor: pointer;
}
@media (max-width: 900px) {
  .ap-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/api-access/api.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Экраны 12–13 «API» (утверждены 28.10.2026). */\n.ap-card-head {\n  padding: 14px 16px 6px;\n}\n.ap-table tbody tr {\n  cursor: pointer;\n}\n.ap-table tbody tr:hover,\n.ap-table tbody tr.is-on {\n  background: var(--v2-bg);\n}\n.ap-row-btn {\n  border: 0;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-weight: 600;\n  color: var(--v2-primary);\n  cursor: pointer;\n}\n.ap-badge {\n  display: inline-block;\n  padding: 2px 9px;\n  border-radius: 999px;\n  background: var(--v2-green-bg);\n  color: var(--v2-green-text);\n  font-size: 12px;\n  font-weight: 600;\n}\n.ap-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 16px;\n  align-items: start;\n}\n.ap-card {\n  padding: 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n.ap-h {\n  font-size: 16px;\n}\n.ap-p {\n  margin: 0;\n  line-height: 1.5;\n}\n.ap-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.ap-label {\n  font-weight: 600;\n  font-size: 13px;\n}\n.ap-label-row {\n  font-size: 13px;\n  flex: 1;\n  min-width: 200px;\n}\n.ap-req {\n  color: var(--v2-red);\n}\n.ap-err {\n  color: var(--v2-red);\n}\n.ap-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.ap-ai {\n  height: 30px;\n  padding: 0 12px;\n  font-weight: 500;\n}\n.ap-input {\n  font: inherit;\n  font-size: 14px;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 9px;\n  color: var(--v2-primary);\n  background: #fff;\n  width: 100%;\n  box-sizing: border-box;\n  outline: none;\n}\n.ap-input:focus {\n  border-color: var(--v2-primary);\n}\n.ap-input.is-error {\n  border-color: var(--v2-red);\n}\n.ap-textarea {\n  height: auto;\n  padding: 10px 12px;\n  resize: vertical;\n  line-height: 1.45;\n}\n.ap-choice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  text-align: left;\n  border: 1px solid var(--v2-border);\n  border-radius: 10px;\n  padding: 12px 16px;\n  background: #fff;\n  font: inherit;\n  cursor: pointer;\n  color: var(--v2-primary);\n}\n.ap-choice > span:last-child {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.ap-choice.is-on {\n  border: 2px solid var(--v2-primary);\n  padding: 11px 15px;\n}\n.ap-choice-t {\n  font-weight: 600;\n  font-size: 14px;\n}\n.ap-radio {\n  flex: none;\n  width: 14px;\n  height: 14px;\n  margin-top: 3px;\n  border-radius: 50%;\n  border: 1.5px solid #9ca3af;\n  box-sizing: border-box;\n}\n.ap-choice.is-on .ap-radio {\n  border: 4px solid var(--v2-blue);\n}\n.ap-submit {\n  height: 44px;\n  border: 0;\n  border-radius: 10px;\n  background: var(--v2-primary);\n  color: #fff;\n  font: inherit;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n}\n.ap-submit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n.ap-existing {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding-top: 12px;\n  border-top: 1px solid var(--v2-border-soft);\n}\n.ap-existing-sel {\n  flex: 1;\n  min-width: 160px;\n  height: 34px;\n}\n.ap-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.ap-chip {\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: var(--v2-hover);\n  font-size: 12px;\n  color: var(--v2-text-2);\n}\n.ap-fresh {\n  border: 1px solid #86efac;\n  background: #f0fdf4;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: var(--v2-green-text);\n}\n.ap-fresh-t {\n  font-weight: 700;\n  font-size: 14px;\n}\n.ap-fresh-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.ap-fresh-key {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  background: #fff;\n  border: 1px solid #bbf7d0;\n  border-radius: 8px;\n  padding: 7px 10px;\n  color: var(--v2-primary);\n  word-break: break-all;\n  user-select: all;\n}\n.ap-fresh-kb {\n  align-self: flex-start;\n}\n.ap-key {\n  background: var(--v2-bg);\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.ap-key-mask {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  color: var(--v2-primary);\n}\n.ap-key-btns {\n  display: flex;\n  gap: 6px;\n}\n.ap-off {\n  color: var(--v2-red);\n}\n.ap-off:hover {\n  border-color: var(--v2-red);\n}\n.ap-tabs {\n  display: flex;\n  gap: 6px;\n}\n.ap-tab {\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid var(--v2-border);\n  border-radius: 8px;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  color: var(--v2-primary);\n}\n.ap-tab.is-on {\n  background: var(--v2-primary);\n  border-color: var(--v2-primary);\n  color: #fff;\n  font-weight: 600;\n}\n.ap-code-wrap {\n  position: relative;\n}\n.ap-code {\n  margin: 0;\n  background: #1f2937;\n  color: #e5e7eb;\n  border-radius: 10px;\n  padding: 16px;\n  font-size: 12.5px;\n  line-height: 1.6;\n  overflow-x: auto;\n}\n.ap-code-copy {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  border: 1px solid #4b5563;\n  background: #374151;\n  color: #e5e7eb;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 11px;\n  padding: 3px 8px;\n  cursor: pointer;\n}\n@media (max-width: 900px) {\n  .ap-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
